import React from 'react';
import classNames from 'classnames';
import Link from 'components/Learn/Content/Sidebar/Link';
import { routes } from 'constants/config';
import { useFeatureFlags } from 'hooks';

const SideNavBar = () => {
  const hasUnificationFlag = useFeatureFlags('readiness-enable-unification');

  return (
    <div className="DashboardSidebar">
      <div className="DashboardSidebar-group">
        <Link
          className={classNames('LearnNavLink DashboardSidebar-link', {
            'DashboardSidebar-link-unification': hasUnificationFlag,
          })}
          to={routes.SKILLS.LIBRARY}
          exact
        >
          {t('skills.sidebar.library')}
        </Link>
        <Link
          className={classNames('LearnNavLink DashboardSidebar-link', {
            'DashboardSidebar-link-unification': hasUnificationFlag,
          })}
          to={routes.SKILLS.PROFILES}
          exact
        >
          {t('skills.sidebar.profiles')}
        </Link>
      </div>
    </div>
  );
};

export default SideNavBar;
